import './AssetCardNewLoading.css';

export function AssetCardNewLoading() {
    return (
        <div className="acnl loading">
            <div className="acnl-img" />
            <div className="acnl-body">
                <div className="acnl-badge" />
                <div className="acnl-name" />
                <div className="acnl-desc-line" />
                <div className="acnl-desc-line acnl-desc-line--short" />
                <div className="acnl-footer">
                    <div className="acnl-stat" />
                    <div className="acnl-stat" />
                </div>
            </div>
        </div>
    );
}

export default AssetCardNewLoading;
